import { BookOpenIcon as HeroBookOpenIcon } from '@heroicons/react/24/outline';
export const BookOpenIcon = HeroBookOpenIcon;
